var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"container-fluid",attrs:{"itemscope":"","itemtype":"http://schema.org/WPFooter"}},[_c('div',{staticClass:"footer"},[_c('Infos')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }